"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

exports.default = loadAMZscript;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Async loader of amazon tag on client
 * @param {function} resolve callback function
 * @param {function} reject callback function
 */
var doloadScript = function doloadScript(resolve, reject) {
  /* eslint-disable */
  if (typeof window.apstag !== 'undefined') {
    resolve(window.apstag);
  }
  !function (a9, a, p, s, t, A, g) {
    if (a[a9]) return;

    function q(c, r) {
      a[a9]._Q.push([c, r]);
    }
    a[a9] = {
      init: function init() {
        q("i", arguments);
      },
      fetchBids: function fetchBids() {
        q("f", arguments);
      },
      setDisplayBids: function setDisplayBids() {},
      _Q: []
    };
    A = p.createElement(s);
    A.async = !0;
    A.src = t;
    g = p.getElementsByTagName(s)[0];
    g.parentNode.insertBefore(A, g);
    A.onerror = function scriptTagOnError(errs) {
      reject(errs);
    };
    A.onload = function scriptTagOnLoad() {
      resolve(a[a9]);
    };
  }("apstag", window, document, "script", "//c.amazon-adsystem.com/aax2/apstag.js");
  /* eslint-enable */
  window.apstag.init({
    pubID: '3087',
    adServer: 'googletag'
  });
};

/**
 * Async loader of gpt tag on client
 * @constructor
 */
function loadAMZscript() {
  return new _promise2.default(function (resolve, reject) {
    doloadScript(resolve, reject);
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/@univision/fe-commons/dist/utils/ads/vendors/amzLoader.js
// module id = 123
// module chunks = 35783957827783 71851226274881